import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../Constant";
import "./CookieConsent.scss";

const CONSENT_KEY = "ef_cookie_consent";
const CONSENT_TIMESTAMP_KEY = "ef_cookie_consent_at";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [preferences, setPreferences] = useState({
    essential: true, // always on
    performance: false,
    functional: false,
    marketing: false,
  });

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      // Small delay so the page loads first
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const saveConsent = (level) => {
    localStorage.setItem(CONSENT_KEY, level);
    localStorage.setItem(CONSENT_TIMESTAMP_KEY, new Date().toISOString());
    setVisible(false);

    // Send consent to backend if user is logged in
    const token = localStorage.getItem("access_token");
    if (token) {
      axios
        .post(
          `${API_BASE_URL}/user/cookie-consent/`,
          { consent_level: level },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .catch(() => {
          // Silent fail - consent is already stored locally
        });
    }
  };

  const handleAcceptAll = () => {
    saveConsent("all");
  };

  const handleDeclineNonEssential = () => {
    saveConsent("essential");
  };

  const handleSavePreferences = () => {
    const consentParts = ["essential"];
    if (preferences.performance) consentParts.push("performance");
    if (preferences.functional) consentParts.push("functional");
    if (preferences.marketing) consentParts.push("marketing");
    saveConsent(consentParts.join(","));
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-consent__inner">
        {!showPreferences ? (
          <>
            <div className="cookie-consent__text">
              <h4 className="cookie-consent__title">We value your privacy</h4>
              <p>
                We use cookies to enhance your browsing experience, analyze site traffic, and
                personalize content. Essential cookies are required for the platform to function.
                You can choose which other cookies you allow.
              </p>
            </div>
            <div className="cookie-consent__actions">
              <button
                className="cookie-consent__btn cookie-consent__btn--accept"
                onClick={handleAcceptAll}
              >
                Accept All
              </button>
              <button
                className="cookie-consent__btn cookie-consent__btn--decline"
                onClick={handleDeclineNonEssential}
              >
                Essential Only
              </button>
              <button
                className="cookie-consent__btn cookie-consent__btn--manage"
                onClick={() => setShowPreferences(true)}
              >
                Manage Preferences
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="cookie-consent__text">
              <h4 className="cookie-consent__title">Cookie Preferences</h4>
              <p>Choose which categories of cookies you would like to allow.</p>
            </div>
            <div className="cookie-consent__preferences">
              <label className="cookie-consent__pref-item">
                <input type="checkbox" checked disabled />
                <div>
                  <strong>Essential Cookies</strong>
                  <span>Required for basic platform functionality (authentication, security).</span>
                </div>
              </label>
              <label className="cookie-consent__pref-item">
                <input
                  type="checkbox"
                  checked={preferences.performance}
                  onChange={(e) =>
                    setPreferences({ ...preferences, performance: e.target.checked })
                  }
                />
                <div>
                  <strong>Performance Cookies</strong>
                  <span>Help us understand how users interact with the platform.</span>
                </div>
              </label>
              <label className="cookie-consent__pref-item">
                <input
                  type="checkbox"
                  checked={preferences.functional}
                  onChange={(e) =>
                    setPreferences({ ...preferences, functional: e.target.checked })
                  }
                />
                <div>
                  <strong>Functional Cookies</strong>
                  <span>Remember your preferences and settings.</span>
                </div>
              </label>
              <label className="cookie-consent__pref-item">
                <input
                  type="checkbox"
                  checked={preferences.marketing}
                  onChange={(e) =>
                    setPreferences({ ...preferences, marketing: e.target.checked })
                  }
                />
                <div>
                  <strong>Marketing Cookies</strong>
                  <span>Used to deliver targeted advertisements.</span>
                </div>
              </label>
            </div>
            <div className="cookie-consent__actions">
              <button
                className="cookie-consent__btn cookie-consent__btn--accept"
                onClick={handleSavePreferences}
              >
                Save Preferences
              </button>
              <button
                className="cookie-consent__btn cookie-consent__btn--manage"
                onClick={() => setShowPreferences(false)}
              >
                Back
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
